import React, {useState} from "react";
import Wizard from "../../../components/Wizard/Wizard";
import connection from "../../../connection";
import Button from "@material-ui/core/Button";
import general from "../../../general";
import {serialize} from "object-to-formdata";
import SeccaoRelatorio from "../../../components/SeccaoRelatorio";

export default function EditarRelatorio({dadosRelatorio, classes, idCurso, onSubmit}) {
  const [step, setStep] = useState(0);

  let steps = dadosRelatorio.dados.map(d => {
    if (!d.editavel)
      return null;
    return {
      stepName: <strong>{d.topico}</strong>,
      stepComponent: () => <SeccaoRelatorio {...d} classes={classes}/>,
      stepId: d.codigo
    }
  }).filter(s => s);

  return <><Wizard
    steps={steps}
    currentStep={step}
    onStepChange={setStep}
  />
    <div style={{display: "flex"}}>
      <Button
        disabled={step === 0}
        className={classes.buttonAnterior + " " + classes.button + " " + classes.info}
        onClick={() => setStep(step => step - 1)}
      >Anterior</Button>
      {step !== (steps.length - 1) ? (
        <Button
          className={classes.buttonSeguinte + " " + classes.button + " " + classes.info}
          onClick={() => setStep(step => step + 1)}
        >Seguinte</Button>) : null}
      <Button
        className={classes.buttonSeguinte + " " + classes.button + " " + classes.primary}
        style={{marginLeft: 10}}
        onClick={() => {
          let formData = serialize(dadosRelatorio, {indices: true, dotsForObjectNotation: true})
          connection.post("curso/relatorio/guardar?curso_id=" + idCurso, formData, (data) => {
            general.success("Relatório atualizado com sucesso.", "Sucesso!");
            onSubmit();
          });
        }}
      >{step === (steps.length - 1) ? "Finalizar" : "Guardar"}
      </Button>
    </div>
  </>
}
